import { createReducer } from '../../store/utils';
import * as actionTypes from './action-types';
import { APP_CLEAR_STORE } from '../authorization/action-types';

const initialState = {
    enableOnlineAuction: false,
    loaded: false,
}

export default createReducer(initialState, {
    [APP_CLEAR_STORE]: () => ({...initialState}),
    [actionTypes.LOADING_FEATURE_FLAGS]: state => ({...state, loaded: false}),
    [actionTypes.GET_ENABLE_ONLINE_AUCTION]: (state, action) => ({...state, enableOnlineAuction: action.payload, loaded: true}),
});
